// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-measure-tools {
  display: flex;
  flex-direction: row-reverse;
  top: 235px;
  right: 17px !important;
}

.button-active {
  background: rgba(255, 255, 255) !important;
  color: #40a9ff !important;
  border: 1px solid #40a9ff;
}

.ol-measure-tools button {
  background-color: #ffffff;
  color: black;
  border: none;
  border-radius: 20px;
  height: 40px;
  width: 40px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1), 2px 0px 36px rgba(0, 0, 0, 0.07);
}

.ol-measure-tools .widget-button.active {
  margin-left: 0.75em;
}

.ol-measure-tools .tool {
  margin-right: 0.25em;
}

.tooltip.hidden {
  display: none;
}

.tooltip,
.tooltip-static {
  position: relative;
  display: inline;
  background-color: #ffcc33;
  color: black;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  border-radius: 4px;
  border: 1px solid white;
}

.tooltip-close {
  position: relative;
  top: -0.3em;
  margin-left: 0.5em;
  font-size: 1em;
  color: black;
}

.tooltip:before,
.tooltip-static:before {
  border-top: 6px solid #ffcc33c5;
  border-top-color: #ffcc33;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: '';
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Map/controls/measuretools/style.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,yBAA8B;EAC9B,yBAA8B;AAChC;;AAEA;EACE,yBAAwB;EACxB,YAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,6EAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAa;AACf;;AAEA;;EAEE,+BAA+B;EAC/B,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["@import '../../../../../assets/scss/variables.scss';\n\n.ol-measure-tools {\n  display: flex;\n  flex-direction: row-reverse;\n  top: 235px;\n  right: 17px !important;\n}\n\n.button-active {\n  background: rgba(255, 255, 255) !important;\n  color: $blue-active !important;\n  border: 1px solid $blue-active;\n}\n\n.ol-measure-tools button {\n  background-color: $white;\n  color: $black;\n  border: none;\n  border-radius: 20px;\n  height: 40px;\n  width: 40px;\n  box-shadow: $box-shadow;\n}\n\n.ol-measure-tools .widget-button.active {\n  margin-left: 0.75em;\n}\n\n.ol-measure-tools .tool {\n  margin-right: 0.25em;\n}\n\n.tooltip.hidden {\n  display: none;\n}\n\n.tooltip,\n.tooltip-static {\n  position: relative;\n  display: inline;\n  background-color: #ffcc33;\n  color: black;\n  padding: 4px 8px;\n  opacity: 0.7;\n  white-space: nowrap;\n  border-radius: 4px;\n  border: 1px solid white;\n}\n\n.tooltip-close {\n  position: relative;\n  top: -0.3em;\n  margin-left: 0.5em;\n  font-size: 1em;\n  color: $black;\n}\n\n.tooltip:before,\n.tooltip-static:before {\n  border-top: 6px solid #ffcc33c5;\n  border-top-color: #ffcc33;\n  border-right: 6px solid transparent;\n  border-left: 6px solid transparent;\n  content: '';\n  position: absolute;\n  bottom: -6px;\n  margin-left: -7px;\n  left: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
